import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { Table } from 'reactstrap';
import { Webhook } from '../../../../APIClient';
import { ActionButton } from '../../../../components';
import { useTranslation } from '../../../../translations';
import { captureError } from '../../../../utils/errorHandling';

export const WebhookTable: FC<{
  readonly webhooks: Webhook[];
  readonly onChange: () => void;
}> = ({ webhooks, onChange }) => {
  const { ts } = useTranslation();
  if (webhooks.length === 0) {
    return <p>{ts('no_webhooks_created')}</p>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <th>#</th>
          <th>{ts('name')}</th>
          <th>{ts('url')}</th>
          <th>{ts('events')}</th>
          <th>{ts('common.actions')}</th>
        </tr>
      </thead>
      <tbody>
        {webhooks.map((wh) => (
          <tr key={wh.id}>
            <td>{wh.id}</td>
            <td>{wh.name}</td>
            <td>{wh.url}</td>
            <td>{wh.events.join(', ')}</td>
            <td>
              <ActionButton
                action={async () => {
                  await api.deleteWebhook(wh.id);
                }}
                color="danger"
                id={`webhook-${wh.name}-delete`}
                onFailure={captureError}
                onSuccess={() => {
                  toast.success(ts('webhook_deleted'));
                  onChange();
                }}
              >
                {ts('common.delete')}
              </ActionButton>{' '}
              <ActionButton
                action={async () => {
                  await api.testWebhook(wh.id);
                }}
                color="warning"
                method="post"
                onFailure={captureError}
                onSuccess={() => {
                  toast.success(ts('success_see_console_for_data'));
                }}
              >
                {ts('webhook.test')}
              </ActionButton>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
